/**
 * Mock data for tasks module
 * Moved from TaskPageNew.tsx
 *
 * Allineato al contratto BE docs/TASK_PROGETTO_BE.md:
 *  - esiste TaskProject (modello), una colonna appartiene sempre a un progetto
 *    (`project_id`/`project_name`) e un task può essere inbox (project/status null);
 *  - i payload restituiti sono autosufficienti: ogni status ripete il proprio
 *    project_id e ogni task include location/project_detail/status_detail.
 *
 * Data persists in-memory during the session (NO localStorage)
 */

// ============================================================
// INITIAL MOCK DATA (read-only templates)
// ============================================================

const INITIAL_PROJECTS = [
  {
    id: 1,
    name: "Progetto predefinito",
    description: "Progetto creato dalla migrazione (BE sezione 5).",
    color: "#7b3fff",
    icon: "folder",
    position: 0,
    is_archived: false,
    archived_at: null,
    created_at: "2026-01-01T00:00:00Z",
    updated_at: "2026-01-01T00:00:00Z",
  },
  {
    id: 2,
    name: "Sviluppo HexisAI",
    description: "Piattaforma AI integrata nel CRM.",
    color: "#3b82f6",
    icon: "sparkles",
    position: 10,
    is_archived: false,
    archived_at: null,
    created_at: "2026-02-01T00:00:00Z",
    updated_at: "2026-02-01T00:00:00Z",
  },
];

const INITIAL_STATUSES = [
  {
    id: 1,
    key: "DA_FARE",
    name: "Da Fare",
    color: "#2b7fff",
    order: 10,
    is_active: true,
    is_default: true,
    project_id: 1,
    project_name: "Progetto predefinito",
  },
  {
    id: 2,
    key: "IN_CORSO",
    name: "In Corso",
    color: "#2b7fff",
    order: 20,
    is_active: true,
    is_default: false,
    project_id: 1,
    project_name: "Progetto predefinito",
  },
  {
    id: 3,
    key: "REVISIONE",
    name: "Revisione",
    color: "#fe9a00",
    order: 30,
    is_active: true,
    is_default: false,
    project_id: 1,
    project_name: "Progetto predefinito",
  },
  {
    id: 4,
    key: "COMPLETATO",
    name: "Completato",
    color: "#00d492",
    order: 40,
    is_active: true,
    is_default: false,
    project_id: 1,
    project_name: "Progetto predefinito",
  },
  {
    id: 5,
    key: "BACKLOG",
    name: "Backlog",
    color: "#8b5cf6",
    order: 10,
    is_active: true,
    is_default: true,
    project_id: 2,
    project_name: "Sviluppo HexisAI",
  },
  {
    id: 6,
    key: "SVILUPPO",
    name: "Sviluppo",
    color: "#3b82f6",
    order: 20,
    is_active: true,
    is_default: false,
    project_id: 2,
    project_name: "Sviluppo HexisAI",
  },
  {
    id: 7,
    key: "DONE",
    name: "Fatto",
    color: "#22c55e",
    order: 30,
    is_active: true,
    is_default: false,
    project_id: 2,
    project_name: "Sviluppo HexisAI",
  },
];

const INITIAL_USERS = [
  { id: 1, username: "Marco Rossi", email: "m.rossi@example.com" },
  { id: 2, username: "Maria Bianchi", email: "m.bianchi@example.com" },
  { id: 3, username: "Sara Verdi", email: "s.verdi@example.com" },
  { id: 4, username: "Luca Neri", email: "l.neri@example.com" },
];

// tasks iniziali: la maggior parte nel progetto predefinito, alcuni nel progetto
// "Sviluppo HexisAI" e un paio di inbox (project/status null).
const INITIAL_TASKS = [
  {
    id: 1,
    title: "Implementare nuova funzionalità di autenticazione",
    description: "Aggiungere OAuth2 e JWT",
    project: 1,
    status: 2,
    position: 0,
    priority: "ALTA",
    due_date: "2026-02-15",
    category: "Backend",
    assigned_to_ids: [1],
    attachments: [{
      id: 1,
      file: "spec.pdf",
      filename: "spec.pdf",
      uploaded_by: "Marco Rossi",
      uploaded_at: "2026-01-20T10:30:00Z"
    }],
    done: false,
    is_completed: false,
    created_by: "Marco Rossi",
    created_at: "2026-01-20",
    updated_at: "2026-01-25",
  },
  {
    id: 2,
    title: "Refactoring del modulo task",
    description: "Migliorare performance e UI",
    project: 1,
    status: 3,
    position: 0,
    priority: "MEDIA",
    due_date: "2026-02-10",
    category: "Frontend",
    assigned_to_ids: [2],
    attachments: [],
    done: false,
    is_completed: false,
    created_by: "Maria Bianchi",
    created_at: "2026-01-18",
    updated_at: "2026-01-24",
  },
  {
    id: 3,
    title: "Aggiornare documentazione API",
    description: "Documentare nuovi endpoint",
    project: 1,
    status: 4,
    position: 0,
    priority: "BASSA",
    due_date: "2026-01-30",
    category: "Documentazione",
    assigned_to_ids: [3],
    attachments: [
      {
        id: 2,
        file: "doc1.pdf",
        filename: "doc1.pdf",
        uploaded_by: "Sara Verdi",
        uploaded_at: "2026-01-15T14:20:00Z"
      },
      {
        id: 3,
        file: "doc2.pdf",
        filename: "doc2.pdf",
        uploaded_by: "Sara Verdi",
        uploaded_at: "2026-01-15T14:25:00Z"
      }
    ],
    done: true,
    is_completed: true,
    created_by: "Sara Verdi",
    created_at: "2026-01-15",
    updated_at: "2026-01-28",
  },
  {
    id: 4,
    title: "Ottimizzare query database",
    description: "Ridurre tempi di risposta",
    project: 1,
    status: 1,
    position: 0,
    priority: "ALTA",
    due_date: "2026-02-20",
    category: "Backend",
    assigned_to_ids: [1],
    attachments: [],
    done: false,
    is_completed: false,
    created_by: "Marco Rossi",
    created_at: "2026-01-22",
    updated_at: "2026-01-22",
  },
  {
    id: 5,
    title: "Implementare sistema di notifiche push",
    description: "Notifiche real-time per gli utenti",
    project: 1,
    status: 2,
    position: 1,
    priority: "MEDIA",
    due_date: "2026-03-01",
    category: "Backend",
    assigned_to_ids: [2, 3],
    attachments: [{
      id: 4,
      file: "wireframe.png",
      filename: "wireframe.png",
      uploaded_by: "Maria Bianchi",
      uploaded_at: "2026-01-20T09:15:00Z"
    }],
    done: false,
    is_completed: false,
    created_by: "Maria Bianchi",
    created_at: "2026-01-20",
    updated_at: "2026-01-26",
  },
  {
    id: 6,
    title: "Creare dashboard analytics",
    description: "Dashboard per visualizzare metriche e KPI",
    project: 1,
    status: 1,
    position: 1,
    priority: "MEDIA",
    due_date: "2026-02-25",
    category: "Frontend",
    assigned_to_ids: [2],
    attachments: [],
    done: false,
    is_completed: false,
    created_by: "Sara Verdi",
    created_at: "2026-01-23",
    updated_at: "2026-01-23",
  },
  {
    id: 7,
    title: "Configurare CI/CD pipeline",
    description: "Setup GitHub Actions per deploy automatico",
    project: 1,
    status: 1,
    position: 2,
    priority: "ALTA",
    due_date: "2026-02-18",
    category: "DevOps",
    assigned_to_ids: [4],
    attachments: [],
    done: false,
    is_completed: false,
    created_by: "Luca Neri",
    created_at: "2026-01-24",
    updated_at: "2026-01-24",
  },
  {
    id: 8,
    title: "Implementare filtri avanzati",
    description: "Aggiungere filtri per status, priority, assignee",
    project: 1,
    status: 2,
    position: 2,
    priority: "MEDIA",
    due_date: "2026-02-12",
    category: "Frontend",
    assigned_to_ids: [3],
    attachments: [],
    done: false,
    is_completed: false,
    created_by: "Sara Verdi",
    created_at: "2026-01-21",
    updated_at: "2026-01-27",
  },
  {
    id: 9,
    title: "Code review modulo autenticazione",
    description: "Revisione codice OAuth2 implementato",
    project: 1,
    status: 3,
    position: 1,
    priority: "ALTA",
    due_date: "2026-02-08",
    category: "Backend",
    assigned_to_ids: [1, 4],
    attachments: [],
    done: false,
    is_completed: false,
    created_by: "Luca Neri",
    created_at: "2026-01-19",
    updated_at: "2026-01-26",
  },
  {
    id: 10,
    title: "Testing integrazione API esterne",
    description: "Test end-to-end per chiamate API terze parti",
    project: 1,
    status: 3,
    position: 2,
    priority: "MEDIA",
    due_date: "2026-02-14",
    category: "Backend",
    assigned_to_ids: [1],
    attachments: [{
      id: 5,
      file: "test_results.pdf",
      filename: "test_results.pdf",
      uploaded_by: "Marco Rossi",
      uploaded_at: "2026-01-25T11:00:00Z"
    }],
    done: false,
    is_completed: false,
    created_by: "Marco Rossi",
    created_at: "2026-01-17",
    updated_at: "2026-01-25",
  },
  {
    id: 11,
    title: "Scrivere user guide",
    description: "Documentazione per utenti finali",
    project: 1,
    status: 4,
    position: 1,
    priority: "BASSA",
    due_date: "2026-01-28",
    category: "Documentazione",
    assigned_to_ids: [2],
    attachments: [{
      id: 6,
      file: "user_guide_v1.pdf",
      filename: "user_guide_v1.pdf",
      uploaded_by: "Maria Bianchi",
      uploaded_at: "2026-01-28T09:30:00Z"
    }],
    done: true,
    is_completed: true,
    created_by: "Maria Bianchi",
    created_at: "2026-01-12",
    updated_at: "2026-01-28",
  },
  {
    id: 12,
    title: "Setup monitoring e logging",
    description: "Configurare Sentry e CloudWatch",
    project: 1,
    status: 4,
    position: 2,
    priority: "ALTA",
    due_date: "2026-01-26",
    category: "DevOps",
    assigned_to_ids: [4],
    attachments: [],
    done: true,
    is_completed: true,
    created_by: "Luca Neri",
    created_at: "2026-01-10",
    updated_at: "2026-01-26",
  },
  // Progetto 2 — Sviluppo HexisAI
  {
    id: 13,
    title: "Integrazione AI agent nel CRM",
    description: "Tool registry con JSON Schema",
    project: 2,
    status: 6,
    position: 0,
    priority: "ALTA",
    due_date: "2026-03-15",
    category: "AI",
    assigned_to_ids: [1],
    attachments: [],
    done: false,
    is_completed: false,
    created_by: "Marco Rossi",
    created_at: "2026-02-05",
    updated_at: "2026-02-10",
  },
  {
    id: 14,
    title: "RAG documentale",
    description: "Pipeline RAG per documenti tenant",
    project: 2,
    status: 5,
    position: 0,
    priority: "MEDIA",
    due_date: "2026-03-20",
    category: "AI",
    assigned_to_ids: [3],
    attachments: [],
    done: false,
    is_completed: false,
    created_by: "Sara Verdi",
    created_at: "2026-02-08",
    updated_at: "2026-02-12",
  },
  // Inbox (project=null, status=null) — task senza progetto
  {
    id: 15,
    title: "Valutare richiesta di demo",
    description: "Lead ha chiesto una demo del prodotto.",
    project: null,
    status: null,
    position: 0,
    priority: "MEDIA",
    due_date: "2026-02-28",
    category: "Sales",
    assigned_to_ids: [],
    attachments: [],
    done: false,
    is_completed: false,
    created_by: "Maria Bianchi",
    created_at: "2026-02-09",
    updated_at: "2026-02-09",
  },
  {
    id: 16,
    title: "Idea: export task in CSV",
    description: "Da capire se prioritario.",
    project: null,
    status: null,
    position: 1,
    priority: "BASSA",
    due_date: null,
    category: "Idea",
    assigned_to_ids: [],
    attachments: [],
    done: false,
    is_completed: false,
    created_by: "Marco Rossi",
    created_at: "2026-02-11",
    updated_at: "2026-02-11",
  },
];

// ============================================================
// IN-MEMORY STATE (mutable during session)
// ============================================================

let projectsState = JSON.parse(JSON.stringify(INITIAL_PROJECTS));
let tasksState = JSON.parse(JSON.stringify(INITIAL_TASKS));
let statusesState = JSON.parse(JSON.stringify(INITIAL_STATUSES));
let usersState = JSON.parse(JSON.stringify(INITIAL_USERS));

// Track next IDs for creating new entities
let nextProjectId = Math.max(...INITIAL_PROJECTS.map(p => p.id), 0) + 1;
let nextTaskId = Math.max(...INITIAL_TASKS.map(t => t.id), 0) + 1;
let nextStatusId = Math.max(...INITIAL_STATUSES.map(s => s.id), 0) + 1;
let nextAttachmentId = Math.max(
  ...INITIAL_TASKS.flatMap(t => t.attachments?.map(a => a.id) || []),
  0
) + 1;

// ============================================================
// SERIALIZERS (shape autosufficienti BE 6.0)
// ============================================================

/**
 * Costruisce lo shape "status autosufficiente" a partire dall'ID.
 *Usato da tutti i mock handler che restituiscono task o status_detail.
 */
export const serializeStatus = (statusId) => {
  if (statusId === null || statusId === undefined) return null;
  const s = statusesState.find((x) => x.id === statusId);
  if (!s) return null;
  return {
    id: s.id,
    key: s.key,
    name: s.name,
    color: s.color,
    order: s.order,
    is_default: s.is_default,
    is_active: s.is_active,
    project_id: s.project_id,
    project_name: s.project_name,
  };
};

/**
 * Costruisce il ProjectSummary (TaskProjectRef) a partire dall'ID.
 */
export const serializeProjectSummary = (projectId) => {
  if (projectId === null || projectId === undefined) return null;
  const p = projectsState.find((x) => x.id === projectId);
  if (!p) return null;
  return {
    id: p.id,
    name: p.name,
    color: p.color,
    icon: p.icon,
    is_archived: p.is_archived,
  };
};

/**
 * Serializza un task nello shape completo BE 6.3:
 *  - location: "project" | "inbox"
 *  - project / status (PK, null per inbox)
 *  - project_detail / status_detail autosufficienti
 *  - assigned_to: array di utenti (risolti da assigned_to_ids)
 *  - priority mappata in formato display (ALTA/MEDIA/BASSA)
 */
export const serializeTask = (task) => {
  const assignedTo = (task.assigned_to_ids || [])
    .map((uid) => usersState.find((u) => u.id === uid))
    .filter(Boolean);

  const statusDetail = serializeStatus(task.status);
  const projectDetail = serializeProjectSummary(task.project);
  const isProjectTask = task.project !== null && task.project !== undefined;

  return {
    id: task.id,
    title: task.title,
    description: task.description || "",
    location: isProjectTask ? "project" : "inbox",
    project: task.project ?? null,
    // `status` PK write field (null per inbox). Manteniamo anche il dettaglio
    // in `status` come oggetto per i consumer non ancora migrati (legacy): in
    // FE-7 i consumer leggeranno `status_detail`. `status_detail` è la fonte
    // autorevole del contratto nuovo.
    status: statusDetail,
    project_detail: projectDetail,
    status_detail: statusDetail,
    position: task.position ?? 0,
    priority: task.priority,
    due_date: task.due_date || null,
    category: task.category || "",
    assigned_to: assignedTo,
    attachments: task.attachments || [],
    done: task.is_completed === true,
    is_completed: task.is_completed === true,
    created_by: task.created_by,
    created_at: task.created_at,
    updated_at: task.updated_at,
  };
};

/**
 * Serializza un progetto con `task_count` e (opzionale) colonne.
 */
export const serializeProject = (project, { includeColumns = false } = {}) => {
  const taskCount = tasksState.filter((t) => t.project === project.id).length;
  const out = {
    id: project.id,
    name: project.name,
    description: project.description || "",
    color: project.color,
    icon: project.icon || "",
    position: project.position,
    is_archived: project.is_archived,
    archived_at: project.archived_at,
    task_count: taskCount,
    created_at: project.created_at,
    updated_at: project.updated_at,
  };
  if (includeColumns) {
    out.columns = statusesState
      .filter((s) => s.project_id === project.id)
      .sort((a, b) => a.order - b.order)
      .map((s) => serializeStatus(s.id));
  }
  return out;
};

// ============================================================
// STATE ACCESSORS & MUTATORS
// ============================================================

export const getProjectsState = () => projectsState;
export const setProjectsState = (newProjects) => { projectsState = newProjects; };

export const getTasksState = () => tasksState;
export const setTasksState = (newTasks) => { tasksState = newTasks; };

export const getStatusesState = () => statusesState;
export const setStatusesState = (newStatuses) => { statusesState = newStatuses; };

export const getUsersState = () => usersState;
export const setUsersState = (newUsers) => { usersState = newUsers; };

export const getNextProjectId = () => nextProjectId++;
export const getNextTaskId = () => nextTaskId++;
export const getNextStatusId = () => nextStatusId++;
export const getNextAttachmentId = () => nextAttachmentId++;

/**
 * Reset all state to initial values (useful for testing)
 */
export const resetMockData = () => {
  projectsState = JSON.parse(JSON.stringify(INITIAL_PROJECTS));
  tasksState = JSON.parse(JSON.stringify(INITIAL_TASKS));
  statusesState = JSON.parse(JSON.stringify(INITIAL_STATUSES));
  usersState = JSON.parse(JSON.stringify(INITIAL_USERS));
  nextProjectId = Math.max(...INITIAL_PROJECTS.map(p => p.id), 0) + 1;
  nextTaskId = Math.max(...INITIAL_TASKS.map(t => t.id), 0) + 1;
  nextStatusId = Math.max(...INITIAL_STATUSES.map(s => s.id), 0) + 1;
  nextAttachmentId = Math.max(
    ...INITIAL_TASKS.flatMap(t => t.attachments?.map(a => a.id) || []),
    0
  ) + 1;
};
